import keyMirror from 'keymirror';

export default keyMirror({
  REQUEST_CATEGORIES: null,
  RECEIVE_CATEGORIES: null,
  ERROR_RECEIVE_CATEGORIES: null,
  SELECT_CATEGORY: null
});
